import React from 'react'
// libs
import { useSelector } from 'react-redux'
// components
import Card from './components/Card'
import Image from './components/Image'
import Section from './components/Section'
import Function from './components/Function'
import ControlButtons from './components/ControlButtons'
import StrategyActions from './components/StrategyActions'
// store
import { currentDashboardSelector, Widget } from 'store/reducers/dashboards'
// types
import { DashboardItemType } from 'types/graphql'
// views
import { WidgetsContainer, WidgetContainer } from './views'

export const getWidgetContent = (widget: Widget) => {
  switch (widget.item.itemType) {
    case DashboardItemType.Card: {
      return <Card data={widget} />
    }
    case DashboardItemType.Image: {
      // eslint-disable-next-line jsx-a11y/alt-text
      return <Image data={widget} />
    }
    case DashboardItemType.Section: {
      return <Section data={widget} />
    }
    case DashboardItemType.Function: {
      return <Function data={widget} />
    }
    case DashboardItemType.StrategyActions: {
      return <StrategyActions data={widget} />
    }
  }
}

const DashboardWidgets: React.FC = () => {
  const currentDashboard = useSelector(currentDashboardSelector)

  const firstLevelWidgets = currentDashboard?.widgets?.filter((widget) => !widget.item.parentDashboardItemId) || []

  return (
    <WidgetsContainer>
      {firstLevelWidgets.map((widget) => (
        <WidgetContainer key={widget.item.id} width={widget.item.settings?.width}>
          {getWidgetContent(widget)}
          <ControlButtons widget={widget} />
        </WidgetContainer>
      ))}
    </WidgetsContainer>
  )
}

export default DashboardWidgets
